<template>
  <div class="search-bg">
    <div class="search-box">
      <div class="search-con">
        <div class="search-title">
          <div class="search-title-l">
            <span>报告库</span>
          </div>
          <div class="search-title-r">
            <div>
              <p>数百份原创报告</p>
              <p>数万次媒体报道</p>
            </div>
          </div>
        </div>

        <div class="search-btn">
          <!-- <el-input
                    class="input-with-select"
                    placeholder="请输入关键词 如：行业名/公司名"
                    v-model="keywords"
                    @keyup.enter.native="getSearch()"
                    @input="inputSearch()"></el-input> -->

          <el-input
            class="input-with-select"
            placeholder="请输入关键词 如：行业名/公司名"
            v-model="keywords"
            @keyup.enter.native="getSearch()"
            @input="inputSearch()"
          >
            <el-select
              class="search-select"
              v-model="select"
              slot="prepend"
              @change="chooseType"
            >
              <el-option label="原创" value="1"></el-option>
              <el-option label="外部" value="2"></el-option>
            </el-select>

            <el-button
              type="primary"
              plain
              slot="append"
              icon="el-icon-search"
              @click="getSearch()"
            ></el-button>
          </el-input>
        </div>

        <!-- <div class="old">
          <el-link href="/zt/Wjsreport/" target="_blank" :underline="false"
            >前往旧版></el-link
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../main'

export default {
    name: 'Search',
    data() {
        return {
            keywords: '',
            type: '1',
            select: '原创'
        }
    },
    methods: {
        getShow() {
            this.$emit('show', false)
        },
        chooseType(val) {
            this.type = val
        },
        getSearch() {
            if(this.type == 2) {
                window.open('http://www.100ec.cn/Index/wjs_search_res.html?kw=报告 ' + this.keywords + '&cgy=zh')
            }else {
                eventBus.$emit('search', this.keywords)
                this.getShow()
            }
        },
        inputSearch() {
            if(this.type == 1) {
                if(this.keywords === '') {
                    eventBus.$emit('search', this.keywords)
                }
            }
        },
    }
}
</script>

<style>
.search-bg {
  color: #fff;
  background: linear-gradient(to right, #6780f8, #7f95d6);
  margin-top: 62px;
}

.search-box {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  height: 260px;
  margin: auto;
}

.search-title {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.search-title-l {
  padding-right: 10px;
}

.search-title-l span {
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 4px;
}

.search-title-r {
  display: flex;
  align-items: center;
  border-left: 1px solid #eee;
  padding-left: 10px;
}

.search-title-r p {
  font-size: 16px;
  line-height: 2;
}

.search-btn {
  display: flex;
  width: 500px;
}

.search-btn .el-input__inner {
  border: none;
}

.search-box .el-input--suffix .el-input__inner {
  width: 80px;
  padding-right: 30px;
}

.old {
  text-align: right;
  margin-top: 10px;
}

.old .el-link {
  color: #eee;
}

.old .el-link:hover {
  color: #fff;
}

@media (max-width: 1200px) {
  .search-con {
    width: 80%;
  }

  .search-btn {
    width: 100%;
  }
}
</style>